// const App = () => import ('../App.vue');
import App from '../App.vue'

const login = r => require.ensure([], () => r(require('../page/login/login.vue')), 'login');
export default {
  path: '/login',
  redirect: '/login',
  component: App,
  children: [
    {
      path: '/login',
      name: 'login',
      component: login
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/login.js